export const createAdminStoreKey = (keyArray: any[]) => {
  const tempArray = keyArray
    .filter((item) => !!item)
    .map((item) => (typeof item !== 'object' ? item.toString() : JSON.stringify(item)));
  const storeKey = ['admin', ...tempArray];

  return storeKey;
};
